import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/homePageJumbotron.png'
import _imports_1 from '@/assets/images/search-engine_1.svg'
import _imports_2 from '@/assets/images/arrow_right.svg'
import _imports_3 from '@/assets/images/call_1.svg'
import _imports_4 from '@/assets/images/document_1.svg'
import _imports_5 from '@/assets/images/report_2.svg'
import _imports_6 from '@/assets/images/translator2.png'
import _imports_7 from '../assets/images/swornapp_footer_logo.png'


const _withScopeId = n => (_pushScopeId("data-v-5793490f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container mx-auto pb-4 px-4" }
const _hoisted_2 = {
  tabindex: "0",
  class: "text-4xl md:text-5xl xl:pb-20 pt-5 i pb-10 break-words"
}
const _hoisted_3 = ["alt"]
const _hoisted_4 = {
  tabindex: "0",
  class: "container pt-20 pb-20 px-4 mx-auto"
}
const _hoisted_5 = { class: "text-[2rem] md:text-[2.5rem] text-center px-4 pb-6 break-words" }
const _hoisted_6 = { class: "text-center text-section mx-auto pb-20" }
const _hoisted_7 = { class: "info-section md:flex md:justify-between items-center md:flex-wrap" }
const _hoisted_8 = { class: "info-card pb-10 md:pb-5" }
const _hoisted_9 = ["alt"]
const _hoisted_10 = ["alt"]
const _hoisted_11 = { class: "info-card pb-10 md:pb-5" }
const _hoisted_12 = ["alt"]
const _hoisted_13 = ["alt"]
const _hoisted_14 = { class: "info-card pb-10 md:pb-5" }
const _hoisted_15 = ["alt"]
const _hoisted_16 = ["alt"]
const _hoisted_17 = { class: "info-card pb-10 md:pb-5" }
const _hoisted_18 = ["alt"]
const _hoisted_19 = {
  key: 0,
  class: "bg-grey-200"
}
const _hoisted_20 = { class: "container pt-20 pb-20 px-4 mx-auto" }
const _hoisted_21 = {
  tabindex: "0",
  class: "text-[2rem] md:text-[2.5rem] text-center pb-10 break-words"
}
const _hoisted_22 = { class: "grid lg:grid-cols-2 gap-6 pb-12 overflow-auto" }
const _hoisted_23 = { class: "text-center show-more-wrapper flex items-center justify-between" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "show-more-line hidden md:inline-block" }, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "show-more-line hidden md:inline-block" }, null, -1))
const _hoisted_26 = { class: "container mx-auto lg:flex lg:px-4 lg:justify-between" }
const _hoisted_27 = {
  tabindex: "0",
  class: "pt-20 pb-20 pr-12 lg:px-0 px-4"
}
const _hoisted_28 = { class: "text-[2rem] md:text-[2.5rem] pb-10 text-center lg:text-left break-words" }
const _hoisted_29 = { class: "pb-8" }
const _hoisted_30 = { class: "pb-8" }
const _hoisted_31 = { class: "pb-8" }
const _hoisted_32 = { class: "list-disc pl-6" }
const _hoisted_33 = ["alt"]
const _hoisted_34 = { class: "container mx-auto lg:flex xl:py-20 py-10 justify-center" }
const _hoisted_35 = { href: "https://swornapp.pl/fundusze-europejskie" }
const _hoisted_36 = ["aria-label"]

import SearchSection from '@/components/SearchSection.vue';
import TranslatorCard from '@/components/TranslatorCard.vue';
import ButtonPrimary from '@/components/atoms/ButtonPrimary.vue';
import router from "@/router";
import {useFrequentlySearchedTranslatorsStore} from "@/stores/frequentlySearchedTranslators.store";
import {storeToRefs} from "pinia";
import {nextTick, watch} from "vue";
import TranslatorCardSkeleton from "@/components/skeletons/TranslatorCardSkeleton.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const frequentlySearchedTranslatorsStore = useFrequentlySearchedTranslatorsStore();
const { frequentlySearchedTranslators, availableMoreFrequentlyTranslators, pageSize, currentTotalCount, isLoadingMoreFrequentlySearchedTranslators } = storeToRefs(frequentlySearchedTranslatorsStore);
frequentlySearchedTranslatorsStore.fetchFrequentlySearchedTranslators();

watch(frequentlySearchedTranslators, async (curr,old) => {
    const firstNewIndex = currentTotalCount.value - pageSize.value;
    if (firstNewIndex > 1) {

        await nextTick();

        let firstNewElem = document.getElementById('home_translator_card_' + (firstNewIndex).toString());
        if (firstNewElem) {
            firstNewElem.focus();
            firstNewElem.scrollIntoView();
        }

    }
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('homeView.findSwornTranslator')), 1),
      _createVNode(SearchSection)
    ]),
    _createElementVNode("img", {
      src: _imports_0,
      alt: _ctx.$t('homeView.imageOfSwornTranslatorAlt'),
      class: "w-full"
    }, null, 8, _hoisted_3),
    _createElementVNode("section", _hoisted_4, [
      _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.$t('homeView.howItWorks')) + "?", 1),
      _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('homeView.itIsEasyText')), 1),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("img", {
            src: _imports_1,
            class: "w-20",
            alt: _ctx.$t('homeView.searchEngineIconAlt')
          }, null, 8, _hoisted_9),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('homeView.searchEngineInfo')), 1)
        ]),
        _createElementVNode("img", {
          src: _imports_2,
          alt: _ctx.$t('homeView.arrowIconAlt'),
          class: "info-array hidden md:block"
        }, null, 8, _hoisted_10),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("img", {
            src: _imports_3,
            class: "w-20",
            alt: _ctx.$t('homeView.contactTheTranslatorIconAlt')
          }, null, 8, _hoisted_12),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('homeView.contactTheTranslatorInfo')), 1)
        ]),
        _createElementVNode("img", {
          src: _imports_2,
          alt: _ctx.$t('homeView.arrowIconAlt'),
          class: "info-array hidden md:block"
        }, null, 8, _hoisted_13),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("img", {
            src: _imports_4,
            class: "w-20",
            alt: _ctx.$t('homeView.sendingDocumentsIconAlt')
          }, null, 8, _hoisted_15),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('homeView.sendingDocumentsInfo')), 1)
        ]),
        _createElementVNode("img", {
          src: _imports_2,
          alt: _ctx.$t('homeView.arrowIconAlt'),
          class: "info-array hidden md:block"
        }, null, 8, _hoisted_16),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("img", {
            src: _imports_5,
            class: "w-20",
            alt: _ctx.$t('homeView.signedTranslationsIconAlt')
          }, null, 8, _hoisted_18),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('homeView.signedTranslationsInfo')), 1)
        ])
      ])
    ]),
    (_unref(frequentlySearchedTranslators).length)
      ? (_openBlock(), _createElementBlock("section", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("h2", _hoisted_21, _toDisplayString(_ctx.$t('homeView.frequentlyChosenTranslators')), 1),
            _createElementVNode("div", _hoisted_22, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(frequentlySearchedTranslators), (translator, index) => {
                return (_openBlock(), _createBlock(TranslatorCard, {
                  name: translator?.basicInfo.name,
                  stars: translator?.basicInfo.stars,
                  count: translator?.basicInfo.successfulOrders,
                  languages: translator.languages,
                  address: translator.address.fullAddress,
                  nameSlug: translator?.basicInfo?.slug?.name,
                  tpNumberSlug: translator?.basicInfo?.slug?.tpNumber,
                  profileImgUrl: translator?.basicInfo?.profileImgUrl,
                  "ask-more-button": "",
                  "ask-for-offer": "",
                  key: index,
                  "translator-card-id": 'home_translator_card_' + index,
                  "name-header": "h3"
                }, null, 8, ["name", "stars", "count", "languages", "address", "nameSlug", "tpNumberSlug", "profileImgUrl", "translator-card-id"]))
              }), 128)),
              (_unref(isLoadingMoreFrequentlySearchedTranslators))
                ? (_openBlock(), _createBlock(TranslatorCardSkeleton, { key: 0 }))
                : _createCommentVNode("", true)
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _createVNode(ButtonPrimary, {
                name: _ctx.$t('homeView.showMore'),
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_unref(frequentlySearchedTranslatorsStore).fetchFrequentlySearchedTranslators(true)), ["prevent"])),
                class: "w-full lg:w-auto mx-2 md:min-w-[12.375rem]"
              }, null, 8, ["name"]),
              _hoisted_25
            ], 512), [
              [_vShow, _unref(availableMoreFrequentlyTranslators)]
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("section", _hoisted_26, [
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("h2", _hoisted_28, _toDisplayString(_ctx.$t('homeView.whoIsSwornTranslator')) + "?", 1),
        _createElementVNode("p", _hoisted_29, _toDisplayString(_ctx.$t('homeView.personOfPublicTrust')), 1),
        _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.$t('homeView.mustCertifyTheComplianceOfTheDocument')), 1),
        _createElementVNode("p", _hoisted_31, _toDisplayString(_ctx.$t('homeView.certifiedTranslationsInclude')) + ":", 1),
        _createElementVNode("div", null, [
          _createElementVNode("ul", _hoisted_32, [
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('homeView.proceduralAndOfficialDocuments')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('homeView.workCertificates')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('homeView.schoolCertificates')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('homeView.notarialDeeds')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('homeView.civilStatusRecords')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('homeView.lawsAndRegulations')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('homeView.certificates')), 1)
          ])
        ])
      ]),
      _createElementVNode("img", {
        src: _imports_6,
        class: "sworn-translator-img object-contain m-auto",
        alt: _ctx.$t('homeView.imageOfSwornTranslatorAlt')
      }, null, 8, _hoisted_33)
    ]),
    _createElementVNode("section", _hoisted_34, [
      _createElementVNode("a", _hoisted_35, [
        _createElementVNode("img", {
          class: "w-full max-w-5xl",
          "aria-label": _ctx.$t('homeView.unia_section'),
          src: _imports_7
        }, null, 8, _hoisted_36)
      ])
    ])
  ], 64))
}
}

})